module.exports = __webpack_public_path__ + "static/img/demo_profile4.5f31f39.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/demo_profile4.png
// module id = x9/7
// module chunks = 150